import React from 'react'
import {
  Container,
  LabelValueContainer,
  Label,
  ValueContainer,
} from './styles/HeaderInfoDisplayer.styles'

interface HeaderInfoDisplayerProps {
  title: string
  children: React.ReactNode
  columns?: number
  symbol?: React.ReactNode
  'data-testid'?: string
  [key: string]: any // For other spread props
}

const HeaderInfoDisplayer: React.FC<HeaderInfoDisplayerProps> = ({
  title,
  children,
  columns = 4,
  'data-testid': dataTestId,
  ...props
}) => {
  return (
    <Container columns={columns} data-testid={dataTestId} {...props}>
      <LabelValueContainer>
        <Label>{title}</Label>
        <ValueContainer>{children}</ValueContainer>
      </LabelValueContainer>
    </Container>
  )
}

export default HeaderInfoDisplayer
